<template>
  <v-card min-width="200" width="320" max-width="425">
    <v-form @submit.prevent="resetPassword">
      <v-card-title>Obnovit heslo</v-card-title>
      <v-card-text>
        <v-text-field v-model="email" type="email" label="Email" outlined dense filled/>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" to="/" text small>Přihlásit se</v-btn>
        <v-spacer/>
        <v-btn color="primary" type="submit" small>Obnovit heslo</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "ResetPasswordFormCard",
  data() {
    return {
      email: null
    }
  },
  methods: {
    resetPassword() {
      this.axios.put('/v1/auth/forgotten-password', {
        email: this.email
      }).then(() => this.$router.push('/'))
    }
  },
}
</script>